<template>
  <div>
    <h2 class="text-center">Assessments</h2>
    <router-link
      to="/assessment"
      class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900 no-underline rounded-full inline-block"
    >
      Create New Assessment
    </router-link>
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}assignments/`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
          classList: "w-1/3",
        },
        { header: { textContent: "Id" }, path: "id" },
        {
          header: { textContent: "Type", sortingParam: "type" },
          path: "type",
        },
        {
          header: { textContent: "Slug" },
          path: "slug",
        },
        {
          header: {
            textContent: "Option",
          },

          path: "id",
          type: "action",
          actionButtonText: "Edit",
          routePath: "/assessment/:id",
        },
      ],
    }
  },
}
</script>
